<template>
  <div class="header">
    <span class="header-title">{{ headTitle }}</span>
    <div class="header-user">
      <el-dropdown trigger="click" @command="clickUser">
        <span class="el-dropdown-link">
          {{ user.name }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            command="personalCenter"
            v-if="user.role === 'teacher'"
            >个人中心</el-dropdown-item
          >
          <el-dropdown-item
            command="personalCenter"
            v-if="
              user.role === 'institution_admin' || user.role === 'school_admin'
            "
            >修改密码</el-dropdown-item
          >
          <el-dropdown-item command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: [],

  components: {},

  data() {
    return {}
  },

  watch: {},

  computed: {
    ...mapState(['user']),
    headTitle() {
      if (this.$regional.copyright === 'hengshui') {
        return '衡水市综合素质评价系统'
      } else if (this.$regional.copyright === 'guilin') {
        return '桂林市综合素质评价系统'
      } else if (this.$regional.copyright === 'wuxi') {
        return '无锡市学生发展服务平台'
      }
    }
  },

  mounted() {},

  methods: {
    clickUser(command) {
      this[command]()
    },

    personalCenter() {
      if (this.user.role === 'teacher') {
        this.$router.push({ name: 'PersonalCenter' })
      } else if (
        this.user.role === 'institution_admin' ||
        this.user.role === 'school_admin'
      ) {
        this.$router.push({ name: 'ResetPassword' })
      }
    },

    async logout() {
      await this.$xhrGet(`/acc/user/logout`)
      this.$store.commit('user/logout')
      this.$router.replace({ name: 'Login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  float: right;
  display: flex;
  align-items: center;
  height: 60px;
  width: calc(100% - 60px);
  background: #ffffff;
}
.header-title {
  height: 28px;
  margin-left: 25px;
  font-size: 20px;
  font-weight: 600;
  color: #444444;
  line-height: 28px;
}
.header-user {
  position: absolute;
  right: 20px;
}
/deep/ .el-dropdown {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue